import invariant from 'invariant';
import React, { ReactNode, createContext } from 'react';

export type SubmitInterceptor = () => void;

type Context = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>;
  getValue: (arg0: string) => unknown;
  updateValue: (
    name: string,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback?: (...args: Array<any>) => any
  ) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateValues: (update: Record<string, any>) => void;
  updateValueWith: (
    name: string | ReadonlyArray<string>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updater: (...args: Array<any>) => any,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback?: (...args: Array<any>) => any
  ) => void;
  setFetchingAddress: (arg0: boolean) => void;
  errors: APIErrors;
  setErrors: (arg0: APIErrors) => void;
  clearErrors: (arg0: Array<string> | null | undefined) => void;
  submitting: boolean;
  updateSubmitting: (arg0: boolean) => void;
  submitDisabled: boolean;
  updateSubmitDisabled: (arg0: boolean) => void;
  fieldQaIdPrefix: string | null | undefined;
  edited: boolean;
  handleError: (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updatedFormData: Record<string, any> | null | undefined
  ) => void;
  addSubmitInterceptor: (interceptor: SubmitInterceptor) => () => void;
};
// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const FormContext = createContext<Context | null | undefined>();
export const FormContextProvider: React.ComponentType<{
  value: Context | null | undefined;
  children?: ReactNode;
}> = FormContext.Provider;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const FormContextConsumer = ({
  children,
}: {
  children: (arg0: Context) => ReactNode;
}) => (
  <FormContext.Consumer>
    {(value) => {
      invariant(value, 'Missing FormContext value');
      return children(value);
    }}
  </FormContext.Consumer>
);
export default FormContext;
